import { render, staticRenderFns } from "./TheLoader2.vue?vue&type=template&id=3462eba4"
import script from "./TheLoader2.vue?vue&type=script&lang=js"
export * from "./TheLoader2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports